"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const apiPaths = [{
  origin: '',
  env: 'local',
  region: 'eu'
}, {
  origin: 'app-stage.adminix.io',
  env: 'staging',
  region: 'us'
}, {
  origin: 'app-eu.adminix.io',
  env: 'production',
  region: 'eu'
}, {
  origin: 'app.adminix.io',
  env: 'production',
  region: 'us'
}];
var _default = apiPaths;
exports.default = _default;